import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import router from "../../../../router";

const updateTranslation = {
    namespaced: true,
    state: {
        dataSaveIsFetching: false,
        textInfoTranslationSave: "",
        typeInfoTranslationSave: "",
        headInfoTranslationSave: "",
        changedItems: [],
    },
    mutations: {
        DATA_SAVE_SUCCESS(state, response) {
            state.typeInfoTranslationSave = "green";
            state.headInfoTranslationSave = response.data.message;
            state.textInfoTranslationSave = response.data.data.textInfo;
            state.dataSaveIsFetching = false;
            let snackbarData = {
                message: response.data.message,
                textInfo: response.data.data.textInfo
            }
            eventBus.$emit("saveTranslationSuccess", snackbarData);
        },
        DATA_SAVE_FAILURE(state, error) {
            state.dataSaveIsFetching = false;
            eventBus.$emit("saveTranslationFailure", error.response.data);
        },
        SET_CHANGED_ITEMS(state, data) {
            if(state.changedItems.filter(el => el.id === data.id).length === 0) {
                state.changedItems.push(data);
            }
        }
    },
    actions: {
        updateTranslation: function({ dispatch, state }, payload) {
            payload.creds.module = router.currentRoute.path;
            state.dataSaveIsFetching = true;
            let promise = sendRequest("post", config.baseURLApi + "/translations", {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1]);
                } else {
                    dispatch("failureDataSave", result[1]);
                }
            });
        },
        requestDataSave: function({ commit }, value) {
            commit("DATA_SAVE_REQUEST", value);
        },
        successDataSave: function({ commit }, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataSave: function({ commit }, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        updateVisibleModal: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL", value);
        },
        addToChangedItems({commit}, data) {
            commit('SET_CHANGED_ITEMS', data);
        }
    }
}

export default updateTranslation;